import React from 'react';

// Components
import { WpModal, WpModalBody } from 'Wpds/components/modal';
import ReviewTemplatePreviewContent from './ReviewTemplatePreviewContent';

type Props = {
  reviewTemplateSlug: string;
  isOpen: boolean;
  toggleIsOpen: () => void;
  isPerformaneReviewTemplate?: boolean;
};

const ReviewTemplatePreviewModal = ({
  reviewTemplateSlug,
  isOpen,
  toggleIsOpen,
  isPerformaneReviewTemplate,
}: Props) => {
  return (
    <WpModal size="full" isOpen={isOpen} onToggle={toggleIsOpen}>
      <WpModalBody>
        <ReviewTemplatePreviewContent
          reviewTemplateSlug={reviewTemplateSlug}
          handleExitClick={toggleIsOpen}
          isPerformaneReviewTemplate={isPerformaneReviewTemplate}
        />
      </WpModalBody>
    </WpModal>
  );
};

export default ReviewTemplatePreviewModal;
